export default __webpack_public_path__ + "static/media/arrow-right.617cd2c0.svg";